import React, { useState, useEffect } from "react";
import "../../styles/banner/Banner.css";
import "../../styles/Slider.css";
import { Arrow90degDown } from "react-bootstrap-icons";
import { TbBriefcase, TbBuildingStore, TbBuildingFactory2 } from "react-icons/tb";
import Image   from "../../assets/img/IndicatorDLE.webp";
import Image2  from "../../assets/img/IndicatorFTQ.webp";
import Image3  from "../../assets/img/IndicatorOEE.webp";
import Image4  from "../../assets/img/Slider.png";
import Image5  from "../../assets/img/Slider2.png";
import Image7  from "../../assets/img/Slider4.png";
import Image8  from "../../assets/img/Slider5.png";
import Image9  from "../../assets/img/Slider6.png";
import Image10 from "../../assets/img/IndicatorMTBF.webp";
import Image11 from "../../assets/img/IndicatorDowntime.webp";
import Image12 from "../../assets/img/IndicatorScrap.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Fade, Slide, AttentionSeeker } from "react-awesome-reveal";
import Banner3D from "./Banner3D";

const sliderImages = [
  Image, Image2, Image3, Image4, Image5,
  Image7, Image8, Image9, Image10, Image11, Image12,
];

const WORDS = [
  { label: "negocio",   icon: <TbBriefcase size={18} /> },
  { label: "pyme",      icon: <TbBuildingStore size={18} /> },
  { label: "industria", icon: <TbBuildingFactory2 size={18} /> },
];

const BannerHome = () => {
  const [wordIndex, setWordIndex] = useState(0);
  const [visible, setVisible]     = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // fade out → swap word → fade in
      setVisible(false);
      setTimeout(() => {
        setWordIndex((i) => (i + 1) % WORDS.length);
        setVisible(true);
      }, 350); // half the CSS transition duration
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  const scrollToNext = () => {
    const next = document.querySelector(".features-video-grid, .eco-section, section");
    if (next) next.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <div
        id="inicio"
        className="banner-container flex-column"
        style={{ position: "relative", overflow: "hidden" }}
      >
        {/* ── 3D background ── */}
        <div className="position-absolute z-1 top-0 bottom-0 start-0 end-0">
          <Banner3D />
        </div>

        {/* ── Overlay ── */}
        <div className="banner-overlay" />

        {/* ── Main content ── */}
        <div className="content" style={{ position: "relative", zIndex: 2 }}>

          {/* Badge */}
          <Fade direction="down" delay={0} duration={800} triggerOnce>
            <div className="banner-label border border-white mx-auto border-opacity-25 mb-5">
              <span className="banner-label-static">Automatización y digitalización para empresas que operan en serio.</span>
            
            </div>
          </Fade>

          {/* Headline */}
          <Fade direction="up" delay={200} duration={900} triggerOnce>
            <h1 className="banner-title w-75 w-md-50 w-lg-50 mx-auto">
              Convertimos operaciones{" "}
              <span className="highlight">críticas</span> en sistemas
              inteligentes que generan{" "}
              <span className="highlight">datos, control</span> y{" "}
              <span className="highlight">rentabilidad.</span>
            </h1>
          </Fade>

          {/* Sub-description */}
          <Fade direction="up" delay={450} duration={900} triggerOnce>
            <p className="banner-description">
              Digitalizamos, conectamos y automatizamos tus procesos para que
              tomes mejores decisiones, más rápido.
            </p>
          </Fade>

          {/* Buttons */}
          <Fade direction="up" delay={650} duration={800} triggerOnce>
            <div className="banner-buttons">
              <button
                className="btn text-white border me-2"
                onClick={scrollToNext}
              >
                <Arrow90degDown className="me-2" />
                Explorar soluciones
              </button>
              <a
                href="https://calendly.com/twinexa-software/30min"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-connect"
              >
                Agendar Diagnóstico Estratégico (Gratis)
              </a>
            </div>
          </Fade>

          {/* Tag-line */}
          <Fade direction="up" delay={900} duration={1000} triggerOnce>
            <h3 className="banner-tagline mt-3">
              ERP + MES + Gemelo Digital + IA.{" "}
              <span className="highlight">Todo conectado. Todo medible.</span>
            </h3>
          </Fade>
          {/* Slider */}
          <Fade delay={1100} duration={1200} triggerOnce>
            <div className="bg-gradient-banner container">
              <Slider
                dots={false}
                arrows={false}
                infinite
                slidesToShow={3}
                slidesToScroll={1}
                autoplay
                speed={4000}
                autoplaySpeed={0}
                cssEase="linear"
                pauseOnHover={false}
              >
                {sliderImages.map((img, index) => (
                  <div key={index} className="container container-slider">
                    <img src={img} alt={`Indicador ${index + 1}`} />
                  </div>
                ))}
              </Slider>
            </div>
          </Fade>
        </div>
      </div>

      {/* Smooth gradient divider instead of hard <hr> */}
      <div className="banner-divider" />
    </>
  );
};

export default BannerHome;
